import axios from 'axios'
import { getUserIdToken } from '@helpers/getUserIdToken'
import { getBackendUrl } from '@helpers/getBackendUrl'
import { logger } from '@helpers/logger'
import { setTestHeaders } from './setTestHeaders'

// Helper function for GET requests
export const getRequest = async (requestKey, params = undefined, noAuth = false) => {
  const idtoken = noAuth ? '' : await getUserIdToken()

  const config = setTestHeaders({
    headers: {
      idtoken,
    },
    params,
  })

  // Log the service request using params
  const logComplete = logger.serviceRequest(requestKey, { params })

  try {
    const response = await axios.get(getBackendUrl(requestKey), config)

    if (response.status !== 200) {
      throw new Error(response)
    }

    return { response: response.data, logComplete } // Return both response and logComplete function
  } catch (error) {
    logger.error(`GET request to ${requestKey} failed`, error)
    logComplete() // Call the completion logging function even on error
    throw error // Re-throw the error after logging
  }
}

// Helper function for POST requests
export const postRequest = async (requestKey, data) => {
  const idtoken = await getUserIdToken()

  const config = setTestHeaders({
    headers: {
      idtoken,
    },
  })

  // Log the service request using data
  const logComplete = logger.serviceRequest(requestKey, { data })

  try {
    const response = await axios.post(getBackendUrl(requestKey), data, config) // Use data directly

    if (response.status !== 200) {
      throw new Error(response)
    }

    return { response: response.data, logComplete } // Return both response and logComplete function
  } catch (error) {
    logger.error(`POST request to ${requestKey} failed`, error)
    logComplete() // Call the completion logging function even on error
    throw error // Re-throw the error after logging
  }
}

// Helper function for PATCH requests
export const patchRequest = async (requestKey, data) => {
  const idtoken = await getUserIdToken()

  const config = setTestHeaders({
    headers: {
      idtoken,
    },
  })

  // Log the service request using data
  const logComplete = logger.serviceRequest(requestKey, { data })

  try {
    const response = await axios.patch(getBackendUrl(requestKey), data, config)

    if (response.status !== 200) {
      throw new Error(response)
    }

    return { response: response.data, logComplete }
  } catch (error) {
    logger.error(`PATCH request to ${requestKey} failed`, error)
    logComplete() // Call the completion logging function even on error
    throw error // Re-throw the error after logging
  }
}

// Helper function for DELETE requests
export const deleteRequest = async (requestKey) => {
  const idtoken = await getUserIdToken()

  const config = setTestHeaders({
    headers: {
      idtoken,
    },
  })

  // Log the service request
  const logComplete = logger.serviceRequest(requestKey, {})

  try {
    const response = await axios.delete(getBackendUrl(requestKey), config)

    if (response.status !== 200) {
      throw new Error(response)
    }

    return { response: response.data, logComplete }
  } catch (error) {
    logger.error(`DELETE request to ${requestKey} failed`, error)
    logComplete() // Call the completion logging function even on error
    throw error // Re-throw the error after logging
  }
}
